import { Component, computed, effect, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { Navbar } from './shared/components/navbar/navbar';
import { AuthService } from './core/auth/auth.service';
import { KEYCLOAK_EVENT_SIGNAL } from 'keycloak-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [Navbar, RouterOutlet],
  template: `
    @if (isPublicRoute()) {
      <router-outlet></router-outlet>
    } @else {
      <app-shell></app-shell>
    }
  `,
  styleUrl: './app.scss'
})
export class App {
  private readonly auth = inject(AuthService);
  private readonly keycloakEvents = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ),
    { initialValue: null }
  );

  protected readonly isPublicRoute = computed(() => {
    const url = this.currentUrl()?.urlAfterRedirects ?? this.router.url;
    return url.startsWith('/01/');
  });

  constructor() {
    // Keep AuthService state in sync with every Keycloak event
    effect(() => {
      this.keycloakEvents();
      this.auth.refreshState();
    });
  }
}
